import { render, staticRenderFns } from "./CollectionImageUpdateScreen.vue?vue&type=template&id=aea2fbb2&"
import script from "./CollectionImageUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./CollectionImageUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports